import React, { useEffect, useState } from "react";
import { useFormContext } from "../../../context/FormContext";
import ActivityJobTrigger from "../../StateMachine/JobTrigger/ActivityJobTrigger";
import { useAxiosContext } from "../../../context/AxiosContext";

const RdbmsJobs = () => {
  const { rdbmsConfig, setRdbmsConfig } = useFormContext();
  const { axiosInstance, handleError } = useAxiosContext();

  const [allJobs, setAllJobs] = useState({});

  const settingPreSubmission = (data) => {
    setRdbmsConfig((prev) => ({
      ...prev,
      rdbms_pre_submission: [...prev.rdbms_pre_submission, ...data]
    }));
  };

  const setJobTriggerFormula = (data) => {
    setRdbmsConfig((prev) => ({
      ...prev,
      rdbms_jobs_trigger_formula: [...prev.rdbms_jobs_trigger_formula, ...data]
    }));
  };

  const settingJobTriggerData = (data) => {
    setRdbmsConfig((prev) => ({
      ...prev,
      rdbms_jobs_trigger: [...prev.rdbms_jobs_trigger, ...data]
    }));
  };

  useEffect(() => {
    const fetchAllTemplatesAndJobs = async () => {
      try {
        const { data: postJobData } = await axiosInstance.get(`/jobs/filter?places=rdbms_post_form_submission`);
        const { data: preSubmissionJobData } = await axiosInstance.get(`/jobs/filter?places=rdbms_pre_form_submission`);

        setAllJobs({
          post_activity: postJobData,
          pre_submission: preSubmissionJobData
        });
      } catch (error) {
        handleError(error);
      }
    };
    fetchAllTemplatesAndJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="sm_inner_left" style={{ height: "calc(100vh - 136px)", margin: "auto" }}>
      <div className="activity_job_trigger">
        <ActivityJobTrigger
          jobTriggerData={rdbmsConfig.rdbms_pre_submission}
          setJobTriggerData={settingPreSubmission}
          stateid={""}
          actId={""}
          allJobs={allJobs.pre_submission || []}
          pageType="statemachine"
          jobType="pre_submission"
        />
        <ActivityJobTrigger
          jobTriggerFormula={rdbmsConfig.rdbms_jobs_trigger_formula}
          setJobTriggerFormula={setJobTriggerFormula}
          jobTriggerData={rdbmsConfig.rdbms_jobs_trigger}
          setJobTriggerData={settingJobTriggerData}
          stateid={""}
          allJobs={allJobs.post_activity || []}
          actId={""}
          pageType="statemachine"
          jobType="post"
        />
      </div>
    </div>
  );
};

export default RdbmsJobs;
